import React from 'react';
import board_icon from "../images/board-icon.png";
import './Board.css'
import ContactTitle, { CTTitle } from "./ContactTitle";

export default function Board() {
    return (
        <div className='board'>
            <ContactTitle src={board_icon}>
                <CTTitle>
                    请留言
                </CTTitle>
            </ContactTitle>
            <div className='board-from'>
                <input className='board-name' type="text" placeholder="姓名:NAME" />
                <input className='board-tel' type="text" placeholder="邮箱:EMAIL" />
                <input className='board-email' type="text" placeholder="电话:TEL" />
                <textarea className='board-message' placeholder="留言:MESSAGE" />
                <button className='board-btn'>提交留言</button>
            </div>
        </div>
    )
}